module.exports = __webpack_public_path__ + "static/media/17.47b09835.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/17.mp3
// module id = 493
// module chunks = 0